import React from 'react';
import { Logo } from './Logo';
export function Header() {
  return <header className="bg-cream" data-id="element-55" data-mp="1laoff7e2s5ra">
      <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-4 sm:px-8" data-id="element-56" data-mp="2dll0t1gihcn3">
        <a href="#top" aria-label="Pawsy Emprende — inicio" data-id="element-57" data-mp="2il7ok4tyuba5">
          <Logo size="sm" data-id="element-58" data-mp="2intvq3cy2oru" />
        </a>
      </div>
    </header>;
}